import { Separator as BaseSeparator } from '@base-ui/react/separator';
import type { ComponentProps } from 'react';
import type { VariantProps } from '@/cva.config';
import { cva, cx } from '@/cva.config';

const separatorVariants = cva({
  base: 'shrink-0',
  defaultVariants: {
    orientation: 'horizontal',
    tone: 'border',
  },
  variants: {
    orientation: {
      horizontal: 'h-px w-full',
      vertical: 'h-full w-px',
    },
    tone: {
      border: 'bg-border',
      'border-active': 'bg-border-active',
    },
  },
});

export interface SeparatorProps
  extends Omit<ComponentProps<typeof BaseSeparator>, 'orientation'>,
    VariantProps<typeof separatorVariants> {}

export const Separator = ({
  className,
  orientation,
  tone,
  ...rest
}: SeparatorProps) => (
  <BaseSeparator
    className={cx(separatorVariants({ orientation, tone }), className)}
    orientation={orientation ?? 'horizontal'}
    {...rest}
  />
);
